
const defaultState = {
  emailRecipient: {},
  requestType: ''
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case 'CREATE_EMAIL_RECIPIENT_REQUEST':
      newState.requestType = action.type;
      return newState;
    case 'CREATE_EMAIL_RECIPIENT_SUCCESS':
      newState.requestType = action.type;
      newState.emailRecipient = action.body;
      return newState;
    case 'CREATE_EMAIL_RECIPIENT_FAILURE':
      newState = defaultState;
      return newState;
    case 'UPDATE_EMAIL_RECIPIENT_REQUEST':
      newState.requestType = action.type;
      return newState;
    case 'UPDATE_EMAIL_RECIPIENT_SUCCESS':
      newState.requestType = action.type;
      newState.emailRecipient = action.body;
      return newState;
    case 'UPDATE_EMAIL_RECIPIENT_FAILURE':
      newState = defaultState;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/email_recipients.js